import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import moment from "moment";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import axiosGet from "../../helpers/axiosGet";

import Button from "../../components/Button/Button";
import Container from "../../components/Container/Container";
import CertificateDetail from "../../components/Detail/CertificateDetail";
import ClaimDetail from "../../components/Detail/ClaimDetail";
import Heading from "../../components/Heading/Heading";
import Spinner from "../../components/Spinner/Spinner";
import StatusBar from "../../components/StatusBar/StatusBar";
import Subheading from "../../components/Subheading/Subheading";

const HistoryDetail = () => {
  const { id } = useParams();
  const decode = window.atob(id);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [detail, setDetail] = useState({});
  const [claim, setClaim] = useState({});
  const [docs, setDocs] = useState([]);
  const [docLod, setDocLod] = useState({});
  const [currentStatus, setCurrentStatus] = useState({});
  const [statusHistory, setStatusHistory] = useState([]);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    axiosGet({
      url: `/claim-recon/attachment/detail/claim/id/${decode}`,
      callback: (res) => {
        setLoading(false);
        setDetail(res.data.claimCargo);
        setClaim(res.data.claimCargo.claim);

        const claimCargoStatus = res.data.claimCargo.claimCargoStatus;
        setStatusHistory(claimCargoStatus);
        setCurrentStatus({
          ...claimCargoStatus[0],
          paymentDate: res.data.claimCargo.claim.paymentDate,
        });

        const claimCargoDocument = res.data.claimCargo.claimCargoDocument;

        setDocs(claimCargoDocument);

        const docLod = claimCargoDocument.filter(
          (doc) => doc.type === "DOC_LOD"
        );
        setDocLod(...docLod);

        const expiredDate = res.data.claimCargo.claim.expiredDate;
        const today = moment();
        const isExpired = moment(today).isAfter(expiredDate);
        setIsExpired(isExpired);
      },
      errorCallback: (err) => {
        setLoading(false);
        setError(err);
      },
    });
  }, [decode]);

  return loading ? (
    <Container>
      <Spinner />
    </Container>
  ) : error && error?.response?.status === 403 ? (
    <Container>
      <div
        className="vh-100 mt-2 mb-2 d-flex justify-content-center align-items-center"
        style={{ minHeight: "200px" }}
      >
        <p className="text-center text-danger">
          Link sudah kadaluwarsa. <br />
          Silakan hubungi WhatsApp berikut:{" "}
          <a
            href="https://api.whatsapp.com/send/?phone=6285157882496"
            target="_blank"
            rel="noreferrer"
          >
            <span>(+62 851-5788-2496)</span>
          </a>{" "}
          untuk informasi lebih lanjut
        </p>
      </div>
    </Container>
  ) : (
    <>
      <section className="overflow-hidden">
        <StatusBar
          id={id}
          detail={detail}
          status={currentStatus}
          claim={claim}
          doc={docLod}
          isExpired={isExpired}
        />

        <MDBContainer>
          <Heading status={currentStatus.statusCode}>DETAIL KLAIM</Heading>

          <MDBRow className="g-4">
            <MDBCol lg="8">
              <ClaimDetail detail={detail} docs={docs} claim={claim} />
            </MDBCol>

            <MDBCol lg="4">
              <Subheading>Detail Certificate</Subheading>

              <CertificateDetail
                detail={detail}
                claim={claim}
                currentStatus={currentStatus}
                docs={docs}
                statusHistory={statusHistory}
              />
            </MDBCol>
          </MDBRow>

          <div className="d-flex justify-content-between mt-5">
            <Button
              secondary
              startIcon="arrow-left"
              onClick={() => {
                window.history.back();
                sessionStorage.setItem("activePage", "history-claim-recon");
              }}
            >
              Kembali
            </Button>
          </div>
        </MDBContainer>
      </section>
    </>
  );
};

export default HistoryDetail;
